<template>
  <div>
    <p>Mensagem original: "{{ message }}"</p>
    <p>Mensagem ao contrário: "{{ reversedMessage }}"</p>
  </div>
</template>

<script >
  
  export default {
    name:'teste',
    data:function(){
      return{
        message: 'Olá Vue'
      }
    },
    methods:{
      carregarDados(){
      }
    },
    computed:{
       reversedMessage: function () {
        
        // `this` aponta para a instância Vue da variável `vm`
        return this.message.split('').reverse().join('')
      }
    },
    mounted(){
      this.carregarDados()
    }
    
  }
</script>